import styled from 'styled-components';
import Down from '../../../../../../../assets/icons/chevron-down.svg';
import Up from '../../../../../../../assets/icons/chevron-up.svg';

export const Label = styled.label.attrs((props: any) => ({
  color: props.color,
  fontWeight: props.fontWeight
}))`
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.color};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : '400')};
  margin-bottom: 5px;
`;

export const ContainerSelect = styled.div.attrs((props: any) => ({
  color: props.color
}))`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  gap: 4px;
  margin-bottom: 16px;

  button {
    background: #ffff;
    box-sizing: border-box;
    padding: 8px 8px 8px 16px;
    gap: 8px;
    width: 100%;
    position: relative;
    text-align: left;
    border: 1px solid ${(props) => props.color};
    border-radius: 4px;

    &:hover {
      cursor: pointer;
    }

    &:after {
      position: absolute;
      right: 6px;
      top: 6px;
      content: url(${Down});
      display: flex;
      align-items: center;
      padding-top: 5px;
      height: 24px;
    }

    &:hover:after {
      background: #e2dffd;
      border-radius: 4px;
    }
    &:active:after {
      background: #c6c0fc;
      border-radius: 4px;
    }
  }

  button.inputError:focus,
  button.inputError {
    border-color: var(--support-error);
  }

  button.expanded::after {
    content: url(${Up});
  }

  button:focus {
    outline: 1px solid #745ef6;
    border: none;
  }

  ul.options {
    box-shadow: 0px 5px 8px rgba(74, 74, 74, 0.22);
    border-radius: 4px;
    background: #ffffff;
    display: none;
    list-style: none;
    padding: 4px 0;
    max-height: 216px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  ul.show {
    display: block;
  }

  ul.options li {
    padding: 10px 16px;
  }

  ul.options li[aria-selected='true'] {
    background: var(--background-background02);
    cursor: pointer;
  }

  ul.options li:hover {
    background: var(--background-01);
    cursor: pointer;
  }

  ul.options li:active,
  ul.options li:focus {
    background: var(--card-focus);
    outline: 0;
  }

  ul.options::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
  }

  ul.options::-webkit-scrollbar-thumb {
    background: #b0c0ca;
    border-radius: 4px;
  }

  .overflow-ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-right: 40px;
  }
`;

export const ContainerInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;

  input,
  textarea {
    border: 1px solid #7a959f;
    padding: 8px 16px;
    border-radius: 4px;
  }

  input[type='text'].inputFilled,
  textarea.inputFilled {
    border: 1px solid var(--neutrals-neutral02);
  }

  input[type='text'].inputFilled:focus,
  textarea.inputFilled:focus {
    border-color: var(--primary-focus);
  }

  input[type='text'].inputError:focus,
  input[type='text'].inputError,
  textarea.inputError:focus,
  textarea.inputError {
    border-color: var(--support-error);
  }

  input::placeholder,
  textarea::placeholder {
    color: #4f6168;
  }

  .inputFilled {
    border-color: yellow;
  }
`;

export const ShowCount = styled.div.attrs((props: any) => ({
  error: props.error
}))`
  justify-content: ${(props) => (props.error ? 'space-between' : 'flex-end')};
  display: flex;
  font-size: 12px;
  color: ${(props) => (props.error ? 'var(--support-error)' : '#4F6168')};
  // margin-bottom: ${(props) => (props.error ? '16px' : '0px')};
`;

export const ShowError = styled.div.attrs((props: any) => ({
  error: props.error
}))`
  align-items: 'flex-start';
  display: flex;
  font-size: 12px;
  color: ${(props) => (props.error ? 'var(--support-error)' : '#4F6168')};
  // margin-bottom: ${(props) => (props.error ? '16px' : '0px')};
`;

export const ShowDefaultError = styled.div`
  font-size: 12px;
`;

export const OptionsContainer = styled.div.attrs((props: any) => ({
  top: props.top
}))`
  background: transparent;
  margin-top: 4px;
  position: absolute;
  z-index: 1;
  width: 100%;
  ${(props) => (props.top ? 'bottom: 45px' : '')};

  &.fixTop {
    bottom: 65px;
  }
`;

export const ContainerRadio = styled.div.attrs((props: any) => ({
  isLineText: props.isLineText
}))`
  input[type='radio'] {
    opacity: 0;
    width: 0px;
  }

  .parenthesis {
    margin-left: 3px;
    font-weight: 400;
    font-size: 14px;
    color: #5b36f2;
  }

  .text {
    position: relative;
    color: var(--text-text02);
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
  }

  .text-bold {
    font-weight: 700;
  }

  img.show {
    margin-right: 8px;
  }

  .circle {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .circle1 {
    background: transparent;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    box-sizing: border-box;
  }

  .circleError {
    width: 20px;
    height: 20px;
    border: 1.25px solid var(--support-error) !important;
    border-radius: 50%;
    box-sizing: border-box;
  }

  .circle2 {
    width: 20px;
    height: 20px;
    border: 1.25px solid var(--neutrals-neutral02);
    border-radius: 50%;
    box-sizing: border-box;
  }

  .circle3 {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    box-sizing: border-box;
  }

  input[type='radio']:checked + .circle1 .circle2 {
    background: var(--primary-hover);
    border: none;
  }

  input[type='radio']:checked + .circle1 .circle2 .circle3 {
    background: #fff;
    border: none;
  }

  .orientationRadioButtons {
    display: flex;
    flex-direction: column;
  }

  // Vertical
  .orientation {
    display: block;
  }

  .circle-label {
    margin: 0 0 8px 0;
  }

  .first-children {
    margin-top: 16px;
  }

  // Horizontal
  @media (min-width: 1280px) {
    .orientation {
      display: ${(props) => (props.isLineText ? 'block' : 'flex')};
      margin: ${(props) => (props.isLineText ? '0' : '0 16px 0 0')};
    }

    .circle-label {
      margin: ${(props) => (props.isLineText ? '0 0 8px 0' : '0 16px 0 0')};
    }
  }

  ////////// MICROINTERACCIONES RADIO BUTTON

  // FOCUS

  input[type='radio'].focus-class:focus + .circle1 {
    background: var(--button-secondary-focus);
    // background: red;
  }

  input[type='radio'].blur-class:focus + .circle1 {
    background: none;
  }

  // input[type="radio"]:checked:focus + .circle1 .circle2 {
  //     background: var(--primary-hover);
  //     border: 1.25px solid var(--primary-hover);
  // }

  // input[type="radio"]:checked:focus + .circle1 .circle2 .circle3 {
  //     background: background: #fff;
  // }

  // Hover

  input[type='radio']:hover + .circle1 {
    background: var(--buton-icon-hover);
    cursor: pointer;
  }

  input[type='radio']:checked:hover + .circle1 {
    background: var(--button-secondary-hover);
  }

  input[type='radio']:checked:hover + .circle1 .circle2 {
    background: var(--primary-hover);
    border: 1.25px solid var(--primary-hover);
  }

  input[type='radio']:checked:hover + .circle1 .circle2 .circle3 {
    background: #fff;
  }
`;

export const ContainerCheckBox = styled.div.attrs((props: any) => ({
  isLineText: props.isLineText
}))`
  input[type='checkbox'] {
    opacity: 0px;
    width: 0px;
  }

  .text {
    position: relative;
    color: var(--text-text02);
    font-size: 14px;
    font-weight: 700;
    display: flex;
    align-items: center;
  }

  .text-bold {
    font-weight: 700;
  }

  .circle__container {
    width: 32px;
  }

  .circle {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .circle1 {
    background: transparent;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    box-sizing: border-box;
    position: static;
  }

  .circle2 {
    width: 16px;
    height: 16px;
    border: 1.25px solid var(--neutrals-neutral02);
    border-radius: 2px;
    box-sizing: border-box;
  }

  .circle3 {
    position: relative;
    left: 0;
    top: -1px;
    width: 4px;
    height: 9px;
    border: solid white;
    border-width: 0 1.5px 1.5px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  input[type='checkbox']:checked + .circle__container .circle1 .circle2 {
    background: var(--primary-hover);
    border: none;
  }

  input[type='checkbox']:checked
    + .circle__container
    .circle1
    .circle2
    .circle3 {
    background: var(--primary-hover);
    // border: none;
  }

  .orientationRadioButtons {
    display: flex;
  }

  // Vertical
  .orientation {
    display: block;
  }

  .circle-label {
    margin: 0 0 0 0;
    cursor: pointer;
  }

  .first-children {
    margin-top: 16px;
  }

  ////////// MICROINTERACCIONES CHECK BOX

  // Hover

  input[type='checkbox']:hover + .circle__container .circle1 {
    background: var(--buton-icon-hover);
    cursor: pointer;
  }

  input[type='checkbox']:hover + .circle__container .circle1 .circle2 .circle3 {
    background: var(--buton-icon-hover);
    border: none;
    cursor: pointer;
  }

  input[type='checkbox']:checked:hover + .circle__container .circle1 {
    background: var(--button-secondary-hover);
  }

  input[type='checkbox']:checked:hover + .circle__container .circle1 .circle2 {
    background: var(--primary-hover);
  }

  input[type='checkbox']:checked:hover
    + .circle__container
    .circle1
    .circle2
    .circle3 {
    border: solid white;
    border-width: 0 1.5px 1.5px 0;
    background: var(--primary-hover);
  }

  // // FOCUS ////////////////////////////////////////////////////////////////

  input[type='checkbox']:not(:checked):focus + .circle__container .circle1 {
    visibility: none;
    border-width: 0 0 0 0;
    background: var(--buton-icon-hover);
  }

  input[type='checkbox']:not(:checked):focus
    + .circle__container
    .circle1
    .circle2
    .circle3 {
    border-width: 0px 0px 0px 0px;
    border: solid var(--buton-icon-hover);
  }

  // /////////////////////////////////////////////////////////////////////////

  input[type='checkbox'].focus-class:checked:focus
    + .circle__container
    .circle1 {
    background: #c6c0fc;
  }

  input[type='checkbox'].focus-class:checked:focus
    + .circle__container
    .circle1
    .circle2 {
    background: #4318cd;
    border: 1.25px solid #4318cd;
  }

  input[type='checkbox'].focus-class:checked:focus
    + .circle__container
    .circle1
    .circle2
    .circle3 {
    border: solid white;
    border-width: 0 1.5px 1.5px 0;
    background: #4318cd;
  }

  // /////////////////////////////////////////////////////////////////////////////

  @media (min-width: 360px) {
    .text {
      display: flex;
      align-items: flex-start !important;
    }
  }

  @media (min-width: 560px) {
    .text {
      display: flex;
      align-items: center !important;
    }
  }
`;

export const ContainerRequestState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  background: #ffffff;
  box-shadow: 0px 2px 8px -4px rgba(176, 192, 202, 0.2);
  border-radius: 8px;
  width: 100%;
  margin-top: 8px;

  .wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .wrapper__content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  @media (min-width: 768px) {
    .wrapper {
      flex-direction: row;
    }
    .wrapper__title {
      text-align: left;
    }
    .wrapper__comentary-text {
      text-align: left;
    }
  }
`;

export const RequestStateTitle = styled.div`
  display: flex;
  justify-content: center;
  text-align: left;
  // margin-bottom: 4px;
  font-weight: 900;
  font-size: 18px;
  line-height: 28px;
  color: #161d1f;

  @media (min-width: 768px) {
    justify-content: left;
  }
`;

export const RequestStateText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #161d1f;

  @media (min-width: 768px) {
    text-align: left;
  }
`;

export const RequestStateDate = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-align: left;
  color: #4f6168;
  margin-bottom: 12px;

  img {
    display: inline-flex;
    margin-right: 5px;
    margin-bottom: 3px;
    filter: invert(21%) sepia(60%) saturate(333%) hue-rotate(184deg)
      brightness(100%) contrast(85%);
  }

  b {
    color: #161d1f;
  }

  @media (min-width: 768px) {
    text-align: left;
  }
`;

export const PendingModifyText = styled.div`
  // font-weight: 400;
  // font-size: 12px;
  // line-height: 16px;
  // text-align: center;
  // color: #4F6168;
  // margin-bottom: 16px;
  color: #161d1f;
  background: #ecf4f9;
  padding: 16px;
  border-radius: 8px;
  gap: 8px;
  margin-bottom: 24px;

  & ul li {
    list-style: initial;
    margin: 0 16px;
  }
`;
